<template>
  <div
    class="horizontal layout center match-answer animate__animated animate__fadeIn px-1"
    :class="{'white': !isTextColourLight}"
  >
    <span
      class="match-answer-item horizontal layout center"
      :class="{
        'm-2': size === 'lg',
        'm-1.5': size === 'md',
        'm-1': size === 'sm',
        'm-0.5': size === 'xs',
      }"
    >
      <AhaSvg
        name="correct"
        view-box="0 0 18 18"
        maintain-color
        :width="correctIconWidth"
        :height="correctIconHeight"
        class="aha-option__icon icon-correct mr-0.5"
      />
      <div
        class="ml-0.5"
        :class="{
          'font-24': size === 'lg',
          'font-22': size === 'md',
          'font-18': size === 'sm',
          'font-14': size === 'xs',
        }"
      >
        <span>{{ numberOfCorrectAnswers | formatNumber }}</span>
        <i v-if="isShowUserIcon" aria-hidden="true" class="fas fa-user fa-sm fa-fw mb-0.5"></i>
      </div>
    </span>
    <span class="line mx-0.5">|</span>
    <span
      class="match-answer-item horizontal layout center"
      :class="{
        'm-2': size === 'lg',
        'm-1.5': size === 'md',
        'm-1': size === 'sm',
        'm-0.5': size === 'xs',
      }"
    >
      <AhaSvg
        name="incorrect"
        view-box="0 0 18 18"
        maintain-color
        :width="incorrectIconWidth"
        :height="incorrectIconHeight"
        class="aha-option__icon icon-incorrect mr-0.5"
      />
      <div
        class="ml-0.5"
        :class="{
          'font-24': size === 'lg',
          'font-22': size === 'md',
          'font-18': size === 'sm',
          'font-14': size === 'xs',
        }"
      >
        <span>{{ numberOfIncorrectAnswers | formatNumber }}</span>
        <i v-if="isShowUserIcon" aria-hidden="true" class="fas fa-user fa-sm fa-fw mb-0.5"></i>
      </div>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const iconSizeMap = {
  lg: 24,
  md: 20,
  sm: 16,
  xs: 12,
}

export default {
  props: {
    numberOfCorrectAnswers: {
      type: Number,
      default: 0,
    },
    numberOfIncorrectAnswers: {
      type: Number,
      default: 0,
    },
    isShowUserIcon: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters(['isTextColourLight']),

    correctIconWidth() {
      return iconSizeMap[this.size]
    },
    correctIconHeight() {
      return iconSizeMap[this.size]
    },
    incorrectIconWidth() {
      return iconSizeMap[this.size]
    },
    incorrectIconHeight() {
      return iconSizeMap[this.size]
    },
  },
}
</script>

<style lang="scss" scoped>
.match-answer {
  background-color: rgba(10, 10, 10, 0.4);
  @apply rounded-lg;
  overflow: hidden;

  &.white {
    background-color: #f0f4fa;
  }

  .aha-option__icon {
    background-color: #fff;
    border-radius: 18px;
  }

  .match-answer-item {
    border-radius: 4px;
  }

  .line {
    color: #D3D7E1;
  }
}
</style>
